import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAlignLeft,
  faEyeSlash,
  faHome,
  faSearch,
  faUserCircle,
  faWallet,
  faCog,
  faFileExcel
} from "@fortawesome/free-solid-svg-icons";
import MagicLineMenu from "react-magic-line-menu";

import { useLocation, useNavigate } from "react-router-dom";
import { Navbar, Button, Nav, Badge, NavItem, NavLink } from "react-bootstrap";
import { logout, useAuthDispatch, useAuthState } from "../../Context";

const tabs = [
  {
    route: "/dashboard",
    icon: faWallet,
    label: "Trésorerie"
  },
  {
    route: "/configuration",
    icon: faCog,
    label: "Configuration"
  },
  {
    route: "/sheets",
    icon: faFileExcel,
    label: "Sheets"
  }
];

function NavBar(props) {
  const location = useLocation() || {};
  const navigate = useNavigate();
  const dispatch = useAuthDispatch();
  const authContext = useAuthState(); //read user de

  const { userDetails = {} } = authContext;
  console.log({ userDetails });
  const {
    firstName,
    lastName,
    entreprises = [{ entrepriseId, entrepriseDenomination }]
  } = userDetails;

  const [{ entrepriseId = "", entrepriseDenomination = "" }] = entreprises;

  const [displayProfileWindow, setDisplayProfileWindow] = useState(false);

  const { pathname = "" } = location;

  const handleLogout = () => {
    logout(dispatch); //call the logout action

    navigate(0); //navigate to dashboard on success
  };

  return (
    <>
      <div
        onMouseLeave={() => setDisplayProfileWindow(false)}
        className={`userProfile-window ${displayProfileWindow ? "" : "hidden"}`}
      >
        <span className="profileName">
          {firstName} {lastName}
        </span>
        <span className="profileEntreprise">{entrepriseDenomination}</span>
        <hr />
        <ul>
          <a onClick={() => navigate("/mon-compte")}>
            <li>Mon compte</li>
          </a>

          <a onClick={handleLogout}>
            <li>Déconnexion </li>
          </a>
        </ul>
      </div>
      <div className="navBarWrapper">
        <div
          className={`userProfile ${displayProfileWindow ? "active" : ""}`}
          onClick={() => setDisplayProfileWindow(!displayProfileWindow)}
        >
          <span className="userButton">
            {firstName.substring(0, 1)}
            {lastName.substring(0, 1)}
          </span>
        </div>

        <Navbar>
          <ul className="navigation">
            {tabs.map(link => {
              const clippedRoute = pathname.split("/");

              return (
                <li>
                  <a
                    onClick={() => navigate(link.route)}
                    className={`${
                      link.route === `/${clippedRoute[1]}` ? "active" : ""
                    }`}
                  >
                    {link.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </Navbar>
        <div
          className="navbar mobile fixed-bottom navbar-light"
          role="navigation"
        >
          <Nav className="w-100">
            <div className=" d-flex flex-row justify-content-around w-100">
              {tabs.map((tab, index) => {
                const clippedRoute = pathname.split("/");

                return (
                  <NavItem key={`tab-${index}`}>
                    <NavLink
                      to={`${tab.route}`}
                      className={`nav-link ${
                        tab.route === `/${clippedRoute[1]}` ? "active" : ""
                      }`}
                      activeClassName="active"
                    >
                      <div className="row d-flex flex-column justify-content-center align-items-center">
                        <FontAwesomeIcon size="lg" icon={tab.icon} />
                      </div>
                    </NavLink>
                  </NavItem>
                );
              })}
            </div>
          </Nav>
        </div>
      </div>
    </>
  );
}

export default NavBar;
